import getTimeDiff from '../getTimeDiff';

import {
  TXTCLI_1_day,
  TXTCLI_1_day_1_hour,
  TXTCLI_1_day_N0_hours,
  TXTCLI_N0_days,
  TXTCLI_N0_days_1_hour,
  TXTCLI_N0_days_N1_hours,
  TXTCLI_N0_h_N1_min,
  TXTCLI_N0_min
} from './getTimeFormatProps.messages.json';

const getTimeFormatProps = (end: number, start: number) => {
  const { days, hours, minutes: minutesDiff } = getTimeDiff(end, start);
  const minutes = !hours && !minutesDiff ? '<1' : minutesDiff.toString();
  let translation;
  let values;

  if (days) {
    if (days === 1) {
      if (hours === 0) {
        translation = TXTCLI_1_day;
      } else if (hours === 1) {
        translation = TXTCLI_1_day_1_hour;
      } else {
        translation = TXTCLI_1_day_N0_hours;
        values = { 0: hours };
      }
    } else {
      if (hours === 0) {
        translation = TXTCLI_N0_days;
        values = { 0: days };
      } else if (hours === 1) {
        translation = TXTCLI_N0_days_1_hour;
        values = { 0: days };
      } else {
        translation = TXTCLI_N0_days_N1_hours;
        values = { 0: days, 1: hours };
      }
    }
  } else if (hours) {
    translation = TXTCLI_N0_h_N1_min;
    values = { 0: hours, 1: minutes };
  } else {
    translation = TXTCLI_N0_min;
    values = { 0: minutes };
  }

  return { translation, values };
};
export default getTimeFormatProps;
